module.exports = {
  title: 'Practice settings',
  address: 'Practice address',
  contactDetails: 'Contact details',
  invoiceData: 'Invoice data',
  invoiceConfig: 'Invoicing config',
  name: 'Practice name',
  shortName: 'Short name',
  rooms: 'Rooms',
  formSteps: {
    name: 'What is your practice name?',
    address: 'What is your practice address?',
    phoneAndEmail: 'What is your practice phone and email address?',
  },
  select: {
    youAreViewing: 'You are viewing',
    clickToSwitch: 'Click to switch to',
  },
  create: {
    buttons: {
      practiceAddress: 'Practice Address',
      contactDetails: 'Contact Details',
      nextStep: 'Next Step',
    },
  },
  logo: {
    image: 'Logo Image',
    uploadOrDrag: 'Upload or drag-and-drop a file',
  },
  branches: {
    all: 'All practice branches',
  },
  settings: {
    title: 'Settings',
    servicesPerTherapist: 'Visibility of services for therapists',
    servicesPerTherapistDescription:
      "When the visibility of services for therapists is enabled, therapists will only have access to the services they've been assigned to. Employees with admin or reception privileges will always have access to all services",
    onlyAdminReception:
      'Only Employees with Admin or Reception privileges can see this page',
  },
  invoice: {
    taxNo: '@:invoices.sidebar.preview.taxNo',
    bankAccount: '@:invoices.sidebar.preview.bankAccount',
    bank: '@:invoices.sidebar.preview.bank',
    save: '@:common.save',
    companyName: '@:invoices.sidebar.preview.companyName',
    companyStreet: 'Company street',
    address: '@:invoices.sidebar.preview.address',
    postCode: 'Post code',
    city: 'City',
    country: 'Country',
    apiKey: 'API key',
    contractor: 'Contractor',
    privatePerson: 'Private person',
    invoicesActive: 'Invoices active',
    apiToken: 'API key',
    subdomain: 'Subdomain',
    fullName: 'Full name',
    email: 'Email',
  },
}
